import { UserPlus, Mail, BookOpen, Wine } from "lucide-react";
import Reveal from "@/components/Reveal";

const steps = [
  { n: "01", Icon: UserPlus, title: "Join The Room", text: "Create a free member account and pull up a chair." },
  { n: "02", Icon: Mail, title: "Get The List", text: "Receive the current reading selections, schedule, and community updates." },
  { n: "03", Icon: BookOpen, title: "Read & Engage", text: "Read at your own pace and join online conversations and discussion prompts." },
  { n: "04", Icon: Wine, title: "Meet Up", text: "RSVP for themed brunches, dinners, reading nights, wine nights & gatherings." },
];

export const HowItWorksSteps = () => (
  <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
    {steps.map((s, i) => (
      <Reveal key={s.n} delay={i * 0.1}>
        <div className="text-center" data-testid={`step-${s.n}`}>
          <div className="relative mx-auto w-20 h-20 mb-6">
            <div className="absolute inset-0 rounded-full border border-gold/40" />
            <div className="absolute inset-0 flex items-center justify-center">
              <s.Icon size={26} className="text-gold" strokeWidth={1.25} />
            </div>
            <span className="absolute -top-2 -right-1 text-fuchsia font-serif text-lg">{s.n}</span>
          </div>
          <h3 className="font-serif text-2xl text-cream mb-3">{s.title}</h3>
          <p className="text-cream/60 text-sm leading-relaxed max-w-[15rem] mx-auto">{s.text}</p>
        </div>
      </Reveal>
    ))}
  </div>
);

export default HowItWorksSteps;
